// extracted by mini-css-extract-plugin
module.exports = {"buttonIcon":"styles_buttonIcon__2OMWm","errorColor":"styles_errorColor__11i8z","moreButton":"styles_moreButton__2fihS"};